(function () {
  'use strict';

  const { iman, ProductComparisonCard, layout, BaseCarousel } = window.Universe;
  const gsap = window.gsap;

  // Dermomamma 22/10/2026: carosello orizzontale da mobile, stesso breakpoint
  // e stesso BaseCarousel (Embla) della featured collection.
  const CAROUSEL_QUERY = '(max-width:768px)';

  /* -- BestChoice ----------------------------------------------------- */

  class BestChoice {
    constructor(section) {
      this.init(section);
    }

    setup() {
      this.animate();
    }

    animate() {
      if (this.DOM.productComparisonCards) {
        const relativeCards = document.querySelectorAll('.comparison-card');
        this.productComparisonCards = [];

        this.DOM.productComparisonCards.forEach((card) => {
          const productComparisonCard = new ProductComparisonCard(card);
          this.productComparisonCards.push(productComparisonCard);
        });

        const handlePrevButton = () => {
          if (this.isCarouselMode()) {
            this.carousel.instance.scrollPrev();
            return;
          }
          BestChoice._reverseAnim = true;
          BestChoice.activeIndex--;
        };

        const handleNextButton = () => {
          if (this.isCarouselMode()) {
            this.carousel.instance.scrollNext();
            return;
          }
          BestChoice.activeIndex++;
        };

        if (this.DOM.prevButton) {
          this.DOM.prevButton.addEventListener('click', handlePrevButton);
          this.DOM.prevButton._eventListeners = { handlePrevButton: handlePrevButton };
        }
        if (this.DOM.nextButton) {
          this.DOM.nextButton.addEventListener('click', handleNextButton);
          this.DOM.nextButton._eventListeners = { handleNextButton: handleNextButton };
        }
      }
    }

    /* -- Carosello mobile (Dermomamma) -- */

    isCarouselMode() {
      return !!(
        this.carousel &&
        this.carousel.instance &&
        window.matchMedia(CAROUSEL_QUERY).matches
      );
    }

    setupCarousel() {
      if (!this.DOM.carousel || !BaseCarousel) return;

      this.onCarouselSelect = () => {
        if (!this.DOM || !this.DOM.announcer || !this.isCarouselMode()) return;
        const embla = this.carousel.instance;
        const template = this.DOM.carousel.dataset.announcement || 'Showing products starting from set [current] of [total]';
        this.DOM.announcer.textContent = template
          .replace('[current]', embla.selectedScrollSnap() + 1)
          .replace('[total]', embla.scrollSnapList().length);
        if (this.isKeyboardInteraction) {
          this.isKeyboardInteraction = false;
          const slide = embla.slideNodes()[embla.slidesInView()[0]];
          const focusable = slide && slide.querySelector('a, button, [tabindex="0"]');
          if (focusable) focusable.focus();
        }
      };

      this.onCarouselKeyDown = (e) => {
        if (!this.isCarouselMode()) return;
        if (!this.DOM.productComparison.contains(document.activeElement)) return;
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.isKeyboardInteraction = true;
          this.carousel.instance.scrollPrev();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.isKeyboardInteraction = true;
          this.carousel.instance.scrollNext();
        }
      };

      this.carousel = new BaseCarousel({
        wrap: this.DOM.productComparison,
        carousel: this.DOM.carousel,
        carouselOptions: {
          containScroll: 'trimSnaps',
          dragFree: true,
          align: 'start',
          loop: false,
          active: false,
          breakpoints: {
            [CAROUSEL_QUERY]: { active: true }
          }
        },
        onReady: (base) => {
          if (!this.DOM) return;
          this.DOM.announcer = document.createElement('div');
          this.DOM.announcer.setAttribute('aria-live', 'polite');
          this.DOM.announcer.setAttribute('aria-atomic', 'true');
          this.DOM.announcer.className = 'sr-only';
          this.DOM.announcer.style.cssText =
            'position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0,0,0,0); white-space: nowrap; border: 0;';
          this.DOM.productComparison.appendChild(this.DOM.announcer);

          base.instance.on('select', this.onCarouselSelect);
          this.DOM.productComparison.addEventListener('keydown', this.onCarouselKeyDown);
        }
      });
    }

    // Toglie gli stili inline lasciati dal mazzo di card (GSAP) quando si
    // entra o si esce dal carosello, cosi le posizioni tornano quelle del CSS.
    resetDeck() {
      BestChoice._activeIndex = 1;
      BestChoice._reverseAnim = false;
      BestChoice._waitForIndex = false;

      if (gsap && this.DOM.productComparisonCards) {
        this.DOM.productComparisonCards.forEach((card) => {
          gsap.killTweensOf(card);
          gsap.set(card, { clearProps: 'transform,pointerEvents' });
          if (card.parentElement) gsap.set(card.parentElement, { clearProps: 'zIndex' });
        });
      }

      if (this.productComparisonCards) {
        this.productComparisonCards.forEach((card) => {
          card.reinit();
        });
      }
    }

    resize() {
      if (this.DOM) {
        this.isMobile = layout.window.width < 1024;

        if (this.isMobile !== this.wasMobile) {
          this.wasMobile = this.isMobile;
          BestChoice._activeIndex = 1;

          this.productComparisonCards.forEach((card) => {
            card.reinit();
          });
        }

        if (this.DOM.carousel) {
          const isCarouselViewport = window.matchMedia(CAROUSEL_QUERY).matches;
          if (isCarouselViewport !== this.wasCarouselViewport) {
            this.wasCarouselViewport = isCarouselViewport;
            this.resetDeck();
          }
        }
      }
    }

    destroy() {
      if (this.DOM) {
        if (this.productComparisonCards) this.productComparisonCards.forEach((card) => { card.destroy(); });

        if (this.carousel) {
          if (this.carousel.instance && this.onCarouselSelect) this.carousel.instance.off('select', this.onCarouselSelect);
          this.carousel.destroy();
          this.carousel = undefined;
        }
        if (this.onCarouselKeyDown) this.DOM.productComparison.removeEventListener('keydown', this.onCarouselKeyDown);
        if (this.DOM.announcer) this.DOM.announcer.remove();

        if (this.DOM.sliderControls) this.DOM.sliderControls.forEach((control) => {
          if (control._eventListeners) {
            const handleClick = control._eventListeners.handleClick;

            control.removeEventListener('click', handleClick);
          }
        });

        if (this.DOM.prevButton) {
          const handlePrevButton = this.DOM.prevButton._eventListeners.handlePrevButton;
          this.DOM.prevButton.removeEventListener('click', handlePrevButton);
        }
        if (this.DOM.nextButton) {
          const handleNextButton = this.DOM.nextButton._eventListeners.handleNextButton;
          this.DOM.nextButton.removeEventListener('click', handleNextButton);
        }

        this.DOM = undefined;
      }
    }

    init(section) {
      if (section) {
        this.DOM = {};
        this.DOM.productComparison = section;
        this.sectionId = section.closest('.shopify-section')?.id || null;
        this.DOM.productComparisonCards = this.DOM.productComparison.querySelectorAll('.js-comparison-card');
        this.DOM.prevButton = this.DOM.productComparison.querySelector('.js-comparison-control-prev');
        this.DOM.nextButton = this.DOM.productComparison.querySelector('.js-comparison-control-next');

        this.DOM.carousel = this.DOM.productComparison.querySelector('.js-best-choice-carousel');

        this.isMobile = layout.window.width < 1024;
        this.wasMobile = this.isMobile;
        this.wasCarouselViewport = window.matchMedia(CAROUSEL_QUERY).matches;

        BestChoice._cardsCount = this.DOM.productComparisonCards.length;

        this.setup();
        this.setupCarousel();
      }
    }
  }

  BestChoice._waitForIndex = false;
  BestChoice._reverseAnim = false;
  BestChoice._activeIndex = 1;
  BestChoice._cardsCount = 0;
  BestChoice.listeners = [];

  Object.defineProperty(BestChoice, 'waitForIndex', {
    get: function () { return this._waitForIndex; },
    set: function (value) {
      if (this._waitForIndex !== value) {
        this._waitForIndex = value;
      }
    },
  });

  Object.defineProperty(BestChoice, 'reverseAnim', {
    get: function () { return this._reverseAnim; },
    set: function (value) {
      if (this._reverseAnim !== value) {
        this._reverseAnim = value;
      }
    },
  });

  Object.defineProperty(BestChoice, 'cardsCount', {
    get: function () { return this._cardsCount; },
    set: function (value) {
      if (this._cardsCount !== value) {
        this._cardsCount = value;
      }
    },
  });

  Object.defineProperty(BestChoice, 'activeIndex', {
    get: function () { return this._activeIndex; },
    set: function (value) {
      if (this._activeIndex !== value && !this.waitForIndex) {
        this._activeIndex = value;
        if (this._activeIndex > this._cardsCount) this._activeIndex = 1;
        if (this._activeIndex < 1) this._activeIndex = BestChoice._cardsCount;

        this.notifyListeners();
      }
    },
  });

  BestChoice.registerListener = function (listener) {
    this.listeners.push(listener);
  };

  BestChoice.notifyListeners = function () {
    this.listeners.forEach((listener) => { listener(this._activeIndex); });
  };

  /* -- BestChoices ---------------------------------------------------- */

  class BestChoices {
    constructor() {
      this._cvObserver = null;
      this._cvPending = new Map();
      this.init();
    }

    // Mirrors the CSS selector: sections 3+ have content-visibility: auto
    _isCVSection(section) {
      let count = 0;
      let prev = section.previousElementSibling;
      while (prev) {
        if (prev.classList.contains('shopify-section') && ++count >= 2) return true;
        prev = prev.previousElementSibling;
      }
      return false;
    }

    _getCVObserver() {
      if (!this._cvObserver) {
        this._cvObserver = new IntersectionObserver((entries) => {
          for (let i = 0; i < entries.length; i++) {
            const entry = entries[i];
            if (!entry.isIntersecting) continue;
            this._cvObserver.unobserve(entry.target);
            const pending = this._cvPending.get(entry.target);
            if (!pending) continue;
            this._cvPending.delete(entry.target);
            for (let j = 0; j < pending.length; j++) {
              if (document.contains(pending[j])) {
                this.instances.push(new BestChoice(pending[j]));
              }
            }
          }
        }, { rootMargin: '200px' });
      }
      return this._cvObserver;
    }

    setup() {
      const isPageRendering = !Shopify.designMode && document.body.hasAttribute('data-page-rendering');

      for (let i = 0; i < this.DOM.sections.length; i++) {
        const section = this.DOM.sections[i];
        const shopifySection = section.closest('.shopify-section');

        if (isPageRendering && shopifySection && this._isCVSection(shopifySection)) {
          const observer = this._getCVObserver();
          if (!this._cvPending.has(shopifySection)) {
            this._cvPending.set(shopifySection, []);
            observer.observe(shopifySection);
          }
          this._cvPending.get(shopifySection).push(section);
        } else {
          this.instances.push(new BestChoice(section));
        }
      }
    }

    resize() {
      if (this.DOM) {
        for (let i = 0; i < this.instances.length; i++) {
          this.instances[i].resize();
        }
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    reinitSection(sectionEl) {
      this.destroySection(sectionEl);

      if (!this.DOM) {
        this.DOM = {};
        this.instances = [];
      }

      const newSections = sectionEl.querySelectorAll('.js-best-choice');
      for (let i = 0; i < newSections.length; i++) {
        const instance = new BestChoice(newSections[i]);
        if (instance.DOM) this.instances.push(instance);
      }

      this.DOM.sections = document.querySelectorAll('.js-best-choice');
    }

    destroySection(sectionEl) {
      if (!this.instances) return;

      const targetId = sectionEl.id || sectionEl.closest('.shopify-section')?.id;
      if (!targetId) return;

      for (let i = this.instances.length - 1; i >= 0; i--) {
        const instance = this.instances[i];
        if (instance.sectionId === targetId) {
          instance.destroy();
          this.instances.splice(i, 1);
        }
      }
    }

    destroy() {
      if (this._cvObserver) {
        this._cvObserver.disconnect();
        this._cvObserver = null;
      }
      this._cvPending = new Map();

      if (this.DOM) {
        for (let i = 0; i < this.instances.length; i++) {
          this.instances[i].destroy();
        }

        this.instances = [];
        this.DOM = undefined;
      }
    }

    init(container = document) {
      const sections = container.querySelectorAll('.js-best-choice');

      if (sections.length) {
        this.DOM = {};
        this.DOM.sections = sections;

        this.instances = [];

        this.setup();
      }
    }
  }

  /* -- Export (before init so cross-file refs work) ------------------- */

  window.Universe.BestChoices = BestChoices;
  window.Universe.BestChoice = BestChoice;

  /* -- Init ---------------------------------------------------------- */

  function init() {
    if (!iman.get('bestChoices')) {
      iman.add('bestChoices', new BestChoices());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
